/* assets/product-gallery-swiper.js */
(() => {
    function initOne(el) {
        if (!window.Swiper) return;
        if (el.__swiper) return;

        const initial = parseInt(el.getAttribute("data-initial-index") || "0", 10);

        const paginationEl = el.querySelector(".swiper-pagination");
        const prevEl = el.querySelector(".swiper-button-prev");
        const nextEl = el.querySelector(".swiper-button-next");

        const swiper = new window.Swiper(el, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,

            // The main fix
            autoHeight: true,

            // Helps when Shopify sections render or media loads late
            observer: true,
            observeParents: true,

            // If you use lazy loading in product-media, this helps too
            preloadImages: true,
            watchSlidesProgress: true,

            pagination: paginationEl
                ? { el: paginationEl, clickable: true }
                : undefined,

            // navigation:
            //     prevEl && nextEl
            //         ? { prevEl, nextEl }
            //         : undefined,

            on: {
                init(s) {
                    // Force height calc after first paint and after images settle
                    requestAnimationFrame(() => s.updateAutoHeight(0));
                    setTimeout(() => s.updateAutoHeight(0), 60);
                    setTimeout(() => s.updateAutoHeight(0), 250);

                    // If images load after init, re-run height
                    el.querySelectorAll("img").forEach((img) => {
                        if (img.complete) return;
                        img.addEventListener(
                            "load",
                            () => {
                                s.updateAutoHeight(0);
                            },
                            { once: true }
                        );
                    });
                },
                slideChangeTransitionEnd(s) {
                    s.updateAutoHeight(200);
                },
                resize(s) {
                    s.updateAutoHeight(0);
                },
            },
        });

        // Start on the variant image if needed
        if (!Number.isNaN(initial) && initial > 0) {
            swiper.slideTo(initial, 0, false);
            swiper.updateAutoHeight(0);
        }

        el.__swiper = swiper;
    }

    function boot() {
        document.querySelectorAll(".product-gallery-swiper").forEach(initOne);
    }

    document.addEventListener("DOMContentLoaded", boot);
    document.addEventListener("shopify:section:load", boot);

    // Optional, if your theme re-renders the product media on variant change
    // document.addEventListener("variant:change", boot);
})();